import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OPTIMIZELY_PROPERTY_SAFELIST = defineFcm('optimizely_property_safelist')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'string',
			},
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'front-end (optimizely)',
		description: `When the front-end sends a tracking event to optimizely (see optimizely_event_safelist), the properties sent alongside the optimizely event are filtered by this safe list.

Related FCM: optimizely_property_safelist`,
		import: false,
		template: ['amount'],
	});
